import { IDatasetTypeMetadata } from 'app/extensibility/metadatas/resource-type/dataset-type-metadata';

import { OracleServiceCloudObjectDataset } from 'app/model/dataset/oracle-service-cloud.dataset';
import { Metamodel } from 'app/model/base/model';
import { OracleServiceCloudLinkedService } from 'app/model/linkedservice/oracle-service-cloud.linkedservice';
import { format } from 'app/shared/utils/string.util';
import { deprecatedConnectorDocLink } from 'app/shared/constants/links.const';

export const oracleServiceCloudObjectMetadata: IDatasetTypeMetadata = {
    type: Metamodel.modelFor(OracleServiceCloudObjectDataset).name,
    displayName: format(stringResources.ModelName_DisplayTextLegacyTemplate, stringResources.OracleServiceCloud_DisplayText),
    supportLinkedServiceTypes: [Metamodel.modelFor(OracleServiceCloudLinkedService).name],
    warningMessage: stringResources.Connector_Legacy_IsDeprecatedWarning,
    warningMessageHyperlink: deprecatedConnectorDocLink,
    isSource: true,
    isSink: false,
    datasetKind: 'table',
    icon: {
        className: 'svg-i-100x100-Oracle'
    },
    isFirstClass: true,
    supportCreatedAsV2: true,
    notSupportPhysicalType: true,
    v1SupportSchema: true,
    category: ['ServicesApps']
};
